module.exports = __webpack_public_path__ + "img/Schipper_a0.a4fb9439.png";